import React from 'react';
import { getFileExtension } from '@ui-framework/index';
import VideoPlayer from './VideoDisplay';
import PDFViewer from './PDFDisplay';
import ImageViewer from './ImageViewer';
import GlobalViewer from './GlobalViewer';
import JsonViewer from './JsonViewer';

// Used by Help Documentation api
export const FILE_TYPE = {
  VIDEO: 'FILE_TYPE_VIDEO',
  PDF: 'FILE_TYPE_PDF',
  IMAGE: 'FILE_TYPE_IMAGE',
  JSON: 'FILE_TYPE_JSON',
};

// export const MODAL_VIEWER_FILE_TYPE = {
//   VIDEO: ['FILE_TYPE_VIDEO', 'mp4'],
//   PDF: ['FILE_TYPE_PDF', 'pdf'],
//   IMAGE: ['FILE_TYPE_IMAGE', 'jpg', 'jpeg', 'gif', 'png', 'heic'],
//   TEXT: ['FILE_TYPE_MSWORD', 'doc', 'docx', 'rtf', 'txt'],
//   SHEET: ['FILE_TYPE_MSEXCEL', 'xls', 'xlsx', 'csv'],
// };

export const MODAL_VIEWER_FILE_TYPE = {
  VIDEO: ['FILE_TYPE_VIDEO', 'mp4'],
  PDF: ['FILE_TYPE_PDF', 'pdf'],
  IMAGE: ['FILE_TYPE_IMAGE', 'jpg', 'jpeg', 'gif', 'png', 'heic'],
  TEXT: ['FILE_TYPE_MSWORD'],
  SHEET: ['FILE_TYPE_MSEXCEL'],
  JSON: ['FILE_TYPE_JSON', 'json'],
};

export const isSupportedByModalViewer = fileName => {
  const supportedExtensions = Object.values(MODAL_VIEWER_FILE_TYPE)
    .flat()
    .filter(value => !value.startsWith('FILE_TYPE_'));
  const extension = getFileExtension(fileName);
  return supportedExtensions.includes(extension);
};

function Viewers({ file, fileType = null }) {
  if (MODAL_VIEWER_FILE_TYPE.VIDEO.includes(fileType)) {
    return <VideoPlayer videoUrl={file} />;
  }
  if (MODAL_VIEWER_FILE_TYPE.PDF.includes(fileType)) {
    return <PDFViewer pdfUrl={file} />;
  }
  if (MODAL_VIEWER_FILE_TYPE.IMAGE.includes(fileType)) {
    return <ImageViewer imageUrl={file} fileType={fileType} />;
  }
  if (MODAL_VIEWER_FILE_TYPE.TEXT.includes(fileType)) {
    return <GlobalViewer fileUrl={file} />;
  }
  if (MODAL_VIEWER_FILE_TYPE.SHEET.includes(fileType)) {
    return <GlobalViewer fileUrl={file} />;
  }
  if (MODAL_VIEWER_FILE_TYPE.JSON.includes(fileType)) {
    return <JsonViewer json={file} />;
  }
  return `Unsupported file type: ${fileType}`;
}

export default Viewers;
